import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import Heading from '../../../components/ui/heading'
import Anchor from '../../../components/ui/anchor'
import {Container, Row, Col} from '../../../components/ui/wrapper'
import SectionTitle from '../../../components/ui/section-title'
import FeatureBox from '../../../components/box-image/layout-one'
import {SectionWrap, SectionBottom} from './management-area.style'

const ManagementArea = (props) => {
    const featuredDataQuery = useStaticQuery(graphql `
        query ManagementQueryData {
            allManagementJson(sort: {order: DESC, fields: id}, limit: 12) {
                edges {
                  node {
                    fields {
                        slug
                    }
                    id
                    title
                    excerpt
                    icon {
                      img{
                        childImageSharp{
                            fixed(width:100, height: 100, quality: 100 ){
                                ...GatsbyImageSharpFixed_tracedSVG
                            }
                        }
                      }
                    }
                  }
                }
            }
        }
    `); 
    const featureData = featuredDataQuery.allManagementJson.edges;
    const {linkStyle, headingStyle} = props;
    return (
        <SectionWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            subtitle="Our Services"
                            title="Property management services for both domestic and commercial customers at competitive prices"
                        />
                    </Col>
                </Row>
                <Row>
                    {featureData.map(feature => (
                        <Col lg={4} md={6} className="box-item" key={feature.node.id}>
                            <FeatureBox
                                title={feature.node.title}
                                imageSrc={feature.node.icon.img.childImageSharp}
                                desc={feature.node.excerpt}
                                path={`/management/${feature.node.fields.slug}`}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </SectionWrap>
    )
}

ManagementArea.propTypes = {
    headingStyle: PropTypes.object,
    linkStyle: PropTypes.object
}

ManagementArea.defaultProps = {
    headingStyle: {
        as: 'h3',
        fontSize: '18px',
        fontweight: 500,
        lineHeight: 1.40,
        color: '#333333'
    },
    linkStyle: {
        layout: 'underline',
        hover: {
            layout: 2
        }
    }
}

export default ManagementArea;